import { clampUsageLimit } from '../../utils/usageContract';
import {
  ApiResponse,
  UsageStats,
  UsageTransactionsResponse,
  UsageHistoryResponse,
  UsageDetailResponse,
} from '../../types/api';
import { api } from './client';

// User usage endpoints
export const usage = {
  /** Суммы за период без разреза. Разбивка по модели есть только в админском /admin/usage/by-model. */
  getStats: async (params?: { from?: string; to?: string }): Promise<ApiResponse<UsageStats>> => {
    const response = await api.get<ApiResponse<UsageStats>>('/usage/stats', { params });
    return response.data;
  },

  getTransactions: async (params?: {
    limit?: number;
    offset?: number;
    from?: string;
    to?: string;
  }): Promise<ApiResponse<UsageTransactionsResponse>> => {
    const response = await api.get<ApiResponse<UsageTransactionsResponse>>('/usage/transactions', {
      params: params ? { ...params, limit: clampUsageLimit(params.limit) } : undefined,
    });
    return response.data;
  },

  // New usage history
  getHistory: async (params?: {
    limit?: number;
    offset?: number;
    from?: string;
    to?: string;
    functionality?: string;
    status?: string;
    exclude_service_usage?: boolean;
  }): Promise<ApiResponse<UsageHistoryResponse>> => {
    const response = await api.get<ApiResponse<UsageHistoryResponse>>('/usage/history', {
      params: params ? { ...params, limit: clampUsageLimit(params.limit) } : undefined,
    });
    return response.data;
  },

  getDetail: async (functionality: string, entityId: string): Promise<ApiResponse<UsageDetailResponse>> => {
    const response = await api.get<ApiResponse<UsageDetailResponse>>(`/usage/history/${functionality}/${entityId}`);
    return response.data;
  },
};
